/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import cx from "clsx";
import TextareaAutosize from "react-textarea-autosize";
import { useContext } from "../../../context";
import { useUpdateNote } from "../../../hooks/useUpdateNote";
import styles from "./styles.module.scss";

export function Notes() {
  const { appointment } = useContext();
  const updateNote = useUpdateNote();

  const [showEditNote, setShowEditNote] = useState(false);
  const [nextNotes, setNextNotes] = useState(appointment.booking.notes);

  const saveNotes = () => {
    if (!updateNote.isLoading) {
      updateNote.initiate({ note: nextNotes }).then(() => {
        setShowEditNote(false);
      });
    }
  };

  return (
    <>
      <div className="detail-row">
        <label>Appointment Notes:</label>
        <div className="editEventCalNote">
          <a onClick={() => setShowEditNote(true)}>
            <i className="far fa-edit"></i>
          </a>
          <TextareaAutosize
            className={cx(
              "setting-input-box no-bg auto-height",
              styles.notesTextarea,
            )}
            name="notes"
            value={nextNotes}
            disabled={!showEditNote ? "disabled" : ""}
            onChange={(e) => setNextNotes(e.target.value)}
          />
        </div>
      </div>
      {showEditNote && (
        <div className="detail-row appointNoteBtn d-flex justify-end">
          <span>
            <a
              className="new-white-btn no-width"
              onClick={() => {
                setShowEditNote(false);
                setNextNotes(appointment.booking.notes);
              }}
            >
              Cancel
            </a>
            <a
              className="new-blue-btn no-width"
              onClick={saveNotes}
              disabled={updateNote.isLoading}
            >
              {updateNote.isLoading ? "Saving..." : "Save"}
            </a>
          </span>
        </div>
      )}
    </>
  );
}
